module.exports = __webpack_public_path__ + "static/media/guests.0ef39540.svg";